import React, {Component} from 'react'
import PropTypes from 'prop-types'


export default class User extends Component {

    onExitClick() {
        this.props.logout();
    }

    render() {
        const {login} = this.props.user;
        const {navigateToPasswordChangePage, translations} = this.props;

        return <ul className='nav justify-content-end'>
            <li className='nav-item'>
                <label className='nav-link'>
                    {translations['user.Hei']}, {login}!
                </label>
            </li>
            <li className='nav-item'>
                <a className='nav-link' onClick={navigateToPasswordChangePage}>
                    {translations['user.Vaihda salasana']}
                </a>
            </li>
            <li className='nav-item'>
                <a className='nav-link' onClick={::this.onExitClick}>
                    {translations['user.Kirjaudu ulos']}
                </a>
            </li>
        </ul>
    }
}

User.propTypes = {
    user: PropTypes.object,
    logout: PropTypes.func,
    getUserBySessionId: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/User.js